<button (click)="onClick()" class="btn btn-outline-light text-dark border-0">
    <fa-icon [icon]="['far', expanded ? 'angle-down' : 'angle-up']" [size]="iconSize"></fa-icon>
</button>
